import * as styled from "./sidebar.styles";

export default function Sidebar({ children }) {
  return <styled.sidebar>{children}</styled.sidebar>;
}
